import React, {Component, Fragment} from 'react';
import './SiteRoot.css';
import {Route, Redirect, Switch, BrowserRouter} from 'react-router-dom';
import Navigation from './Navigation/Navigation';
import Register from '../Register/Register';
import UserProfile from '../UserProfile/UserProfile';
import Login from '../Login/Login';
import Cart from '../Cart/Cart';
import OrderConfirmation from '../Order/OrderConfirmation/OrderConfirmation';
import HomeContent from '../HomeContent/HomeContent';
import Logout from '../../../Logout';
import UserInquiryForm from "../UserInquiryForm/UserInquiryForm";
import UserInquiry from "../UserInquiry/UserInquiry";
import QuotationForm from "../QuotationForm/QuotationForm";
import Authenticate from "../../Common/Authenticate/Authenticate";
import axios from "axios";
import {GOOGLE_ANALYTICS_CODE, IS_IN_MOBILE_MODE, RESOURCE_BASE_URL} from "../../../configuration";
import UserChat from "../UserChat/UserChat";
import OrderHistory from "../Order/OrderHistory/OrderHistory";
import ViewSingleCustomerOrder from "../Order/SingleOrder/ViewSingleCustomerOrder/ViewSingleCustomerOrder";
import LastOrder from "../UserProfile/LastOrderView/ViewSingleCustomerOrder/ViewSingleCustomerOrder"
import GerberReview from "../GerberReview/GerberReview";
import ChangePassword from "../../../ChangePassword";
import PasswordChange from "../PasswordChange/PasswordChange";
import NavigationPage1 from "../HomeContent/FooterNavigationPages/MenuContentPages/NavigationPage1";
import NavigationPage2 from "../HomeContent/FooterNavigationPages/MenuContentPages/NavigationPage2";
import NavigationPage3 from "../HomeContent/FooterNavigationPages/MenuContentPages/NavigationPage3";
import NavigationPage4 from "../HomeContent/FooterNavigationPages/MenuContentPages/NavigationPage4";
import NavigationPage5 from "../HomeContent/FooterNavigationPages/MenuContentPages/NavigationPage5";
import NavigationPage6 from "../HomeContent/FooterNavigationPages/MenuContentPages/NavigationPage6";
import NoticeArticle from "../HomeContent/InformationNotice/ArticleItem/NoticeArticle";
import LinkedSamplePage from "../QuotationForm/LinkedSamplePage";
import CalculationMainPage from "../QuotationForm/ImpedanceCalculator/CalculationMainPage";
import StackUp from "../QuotationForm/ImpedanceCalculator/StackUp/StackUp";
import ManufactureDocument
    from "../HomeContent/ImageSlider/ImageSliderQuotation/SliderQuotationContent3/ManufactureDocument";
import Beginners from "./Navigation/LinkPages/Beginners";
import Payment from "./Navigation/LinkPages/Payment";
import Delivery from "./Navigation/LinkPages/Delivery";
import FAQ from "./Navigation/LinkPages/FAQ";
import CalendarPage from "./Navigation/LinkPages/CalendarPage";
import Flow from "./Navigation/LinkPages/Flow";
import Privacy from "./Navigation/LinkPages/Privacy";
import Warranty from "./Navigation/LinkPages/Warranty";
import Spec from "./Navigation/LinkPages/Spec";
import Information from "./Navigation/LinkPages/Information";
import ContactByChat from "./Navigation/LinkPages/ContactByChat";
import Inquiry from "./Navigation/LinkPages/Inquiry";
import Guide from "./Navigation/LinkPages/Guide";
import MaterialDetail from "../QuotationForm/MaterialDetail";
import Layer from "../QuotationForm/Layer";
import Dimensions from "../QuotationForm/Dimensions";
import PCBQty from "../QuotationForm/PCBQty";
import PCBThickness from "../QuotationForm/PCBThickness";
import PCBColor from "../QuotationForm/PCBColor";
import CopperWeight from "../QuotationForm/CopperWeight";
import GoldFingers from "../QuotationForm/GoldFingers";
import FlyingProbeTest from "../QuotationForm/FlyingProbeTest";
import CastellatedHoles from "../QuotationForm/CastellatedHoles";
import DifferentDesign from "../QuotationForm/DifferentDesign";
import SurfaceFinish from "../QuotationForm/SurfaceFinish";
import PanelByJLCPCB from "../QuotationForm/PanelByJLCPCB";
import CustomsRequirements from "../../Site/SiteRoot/Navigation/LinkPages/FaqPages/CustomsRequirements";
import DataCreationAndUpload from "../../Site/SiteRoot/Navigation/LinkPages/FaqPages/DataCreationAndUpload";
import DeliveryTime from "../../Site/SiteRoot/Navigation/LinkPages/FaqPages/DeliveryTime";
import OperatingCompany from "../../Site/SiteRoot/Navigation/LinkPages/FaqPages/OperatingCompany";
import Other from "../../Site/SiteRoot/Navigation/LinkPages/FaqPages/Other";
import ProductSpecifications from "../../Site/SiteRoot/Navigation/LinkPages/FaqPages/ProductSpecifications";
import QualityAssurance from "../../Site/SiteRoot/Navigation/LinkPages/FaqPages/QualityAssurance";
import Shipping from "../../Site/SiteRoot/Navigation/LinkPages/FaqPages/Shipping";
import YourOrder from "../../Site/SiteRoot/Navigation/LinkPages/FaqPages/YourOrder";
import MemberRegistration from "../../Site/SiteRoot/Navigation/LinkPages/FaqPages/MemberRegistration";
import AboutPayment from "../../Site/SiteRoot/Navigation/LinkPages/FaqPages/AboutPayment";
import Cancellation from "../../Site/SiteRoot/Navigation/LinkPages/FaqPages/Cancellation";
import QuotationFieldsHelp from "../../Site/QuotationForm/QuotationFieldsHelp";

import CustomsRequirementsTopic
    from "../../Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/CustomsRequirementsTopics";
import DataCreationAndUploadTopic
    from "../../Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/DataCreationAndUploadTopics";
import DeliveryTimeTopic from "../../Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/DeliveryTimeTopics";
import OperatingCompanyTopic from "../../Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/OperatingCompanyTopics";
import OtherTopic from "../../Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/OtherTopics";
import ProductSpecificationsTopic
    from "../../Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/ProductSpecificationsTopics";
import QualityAssuranceTopic from "../../Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/QualityAssuranceTopics";
import ShippingTopic from "../../Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/ShippingTopics";
import YourOrderTopic from "../../Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/YourOrderTopics";
import MemberRegistrationTopic from "../../Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/MemberRegistrationTopics";
import AboutPaymentTopic from "../../Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/AboutPaymentTopics";
import CancellationTopic from "../../Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/CancellationTopics";


import Footer from "../../Site/HomeContent/Footer/Footer"
import Impedance from "../QuotationForm/Impedance";

import footerNavPage1 from "../../Site/HomeContent/FooterNavigationPages/FooterNavPages/page1"
import footerNavPage2 from "../../Site/HomeContent/FooterNavigationPages/FooterNavPages/page2"
import footerNavPage3 from "../../Site/HomeContent/FooterNavigationPages/FooterNavPages/page3"
import footerNavPage4 from "../../Site/HomeContent/FooterNavigationPages/FooterNavPages/page4"
import footerNavPage5 from "../../Site/HomeContent/FooterNavigationPages/FooterNavPages/page5"
import footerNavPage6 from "../../Site/HomeContent/FooterNavigationPages/FooterNavPages/page6"


import InformationList from "./Navigation/LinkPages/InformationList";
// import FAQSearchList from "./Navigation/LinkPages/FaqPages/FAQSearchList";
import CompanyProfile from "./Navigation/LinkPages/CompanyProfile";
import InitialQuotationState from "../QuotationForm/InitialQuotationState";
import ComplaintNew from "../QualityComplaintNew/ComplaintNew";
import UserProfileSettingMobile from "../UserProfile/UserProfileInfo/UserProfileSettingMobile/UserProfileSettingMobile";
import UserEditProfileInfo from "../UserProfile/UserProfileInfo/UserProfileInfo";
import ReactGA from "react-ga";
import StripeSuccessComponent from "../Order/OrderConfirmationBottom/StripeComponents/StripeSuccessComponent";
import StripeFailComponent from "../Order/OrderConfirmationBottom/StripeComponents/StripeFailComponent";
import PaymentCancelledComponent from "../Order/OrderConfirmationBottom/StripeComponents/PaymentCancelledComponent";
import InquiryStaticPage from "../UserInquiry/InquiryStaticPage";
import RegisterMsg from "../Register/RegisterMsg";
import EmailVerify from "../Login/EmailVerify";
import RecoverPassword from "../RecoverPassword/RecoverPassword";
import ChangeFogotPassword from "../ChangeFogotPassword/ChangeFogotPassword";
import ChageFogotPassword from "../ChangeFogotPassword/ChangeFogotPassword";
import Emailexpire from "../Register/Emailexpire";
import AdminRoot from "../../Admin/AdminRoot/AdminRoot";
import AlreadyVerifiedEmail from "../Register/AlreadyVerifiedEmail";
import OAuth2Handler from "../Login/OAuth2Handler";

class SiteRoot extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: "",
            cartItems: [],
            user: {},
            cartItemCount: 0,
            isGettingCartItems: false
        };
        // console.log("ddddddddd ", props);
        this.getCartItemsLocal = this.getCartItemsLocal.bind(this);
        this.getCartItems = this.getCartItems.bind(this);
        this.getUser = this.getUser.bind(this);
        this.getCartItemCountForUser = this.getCartItemCountForUser.bind(this);
        this.getUserID = this.getUserID.bind(this);
    }

    componentDidMount() {
        if (this.props.userData && this.props.userData.userId) {
            this.setState({userId: this.props.userData.userId});
            this.getUserID();
            // this.getCartItemsLocal(this.props.userData.userId);
            // this.getUser(this.props.userData.userId);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevProps.userData !== this.props.userData) {
            console.log("user profile user id ===> " + this.props.userId)
            this.setState({userId: this.props.userData.userId});
            this.getCartItemsLocal(this.props.userId);
            this.getUser(this.props.userId);
        }


        let url = window.location.href;

        var stringArray = url.split("/");
        let str = stringArray[3];

        var x = document.getElementById("to_hide_navbar");
        var y = document.getElementById("To_Hide_Navbar");
        var z = document.getElementById("footer-control");

        if(!IS_IN_MOBILE_MODE) {
            if(str === "admin" || str === "register" || str === "registered" || str === "login" || str === "forgotPassword" || str === "expired-email" || str === "auth" || str === "alreadyVerified"){
                x.style.display = 'none';
                y.style.display = 'none';
                z.style.display = 'none';
            }else {
                x.style.display = 'block';
                y.style.display = 'block';
                z.style.display = 'block';
            }
        }

    }

    getUserID = () => {
        let tokenString;
        if (localStorage.getItem("userRole") === "ROLE_IMPERSONATE") {
            tokenString = localStorage.getItem("newTokenString");
        } else {
            tokenString = localStorage.getItem("tokenString")
        }
        let axiosConfig = {
            headers: {
                'Authorization': tokenString.toString()
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/user-new', axiosConfig)
            .then((res) => {
                let userId = res.data.payload.id;
                const user = res.data.payload;
                console.log("get user : ", user);
                this.setState({
                    userId: userId
                })
                this.getUser(userId);

            }).catch((err) => {
            console.log("Get user Id error", err);
        })
    }

    getUser = (userId) => {

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        let resourceUrl = RESOURCE_BASE_URL + 'api/users/' + userId;

        axios.get(resourceUrl, axiosConfig)
            .then((res) => {
                console.log("siteroot getUser ===>", res.data);

                this.setState({
                    user: res.data

                }, () => {
                    this.getCartItemsLocal(userId);
                    if (InitialQuotationState.naviUserName === "" || InitialQuotationState.naviUserName === null) {
                        InitialQuotationState.naviUserName = this.state.user.username;
                        InitialQuotationState.loggedUserId = res.data.id;

                    }
                    // InitialQuotationState.naviUserName = this.state.user.username;
                });
                // console.log("USER DETAILS DUO =====> ", res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

    };


    getCartItems = () => {
        if (this.props.userData && this.props.userData.userId) {
            this.getCartItemsLocal(this.props.userId);

        }
    };

    getCartItemCountForUser = (userId) => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        let resourceUrlItemCount = RESOURCE_BASE_URL + 'api/users/' + userId + '/cart/items/count';

        axios.get(resourceUrlItemCount, axiosConfig)
            .then((res) => {
                // console.log("ITEM COUNT DUOOO NEW ==== > ", res.data);
                this.setState({
                    cartItemCount: res.data
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    getCartItemsLocal = (userId) => {

        this.setState({
            isGettingCartItems: true
        });

        this.getCartItemCountForUser(userId);
        // console.log("[DEBUG] Fetching cart items for user: ", this.state.userId);
    };

    render() {
        ReactGA.initialize(GOOGLE_ANALYTICS_CODE);
        ReactGA.pageview(window.location.pathname + window.location.search);
        return (
            <Fragment>
                <Navigation
                    onLanguageChange={this.props.onLanguageChange}
                    authenticate={this.props.authenticate}
                    userData={this.props.userData}
                    loggedIn={this.props.authenticated}
                    isAdmin={this.props.isAdmin}
                    cartItemsCount={this.state.cartItemCount}
                    userId={this.props.userId}
                    user={this.props.userData}/>



                <Fragment>
                    <Switch>
                        <Route path='/order/view/:orderId'
                               render={(props) =>
                                   <ViewSingleCustomerOrder {...props}
                                                            authenticate={this.props.authenticate}
                                                            userData={this.props.userData}
                                                            authenticated={this.props.authenticated}
                                                            userId={this.props.userId}/>
                               }/>

                        <Route path='/admin'
                               render={(props) =>
                                   <AdminRoot
                                       userData={this.props.userData}
                                       authenticated={this.props.authenticated}
                                       authenticate={this.props.authenticate}
                                       onLanguageChange={this.props.onLanguageChange}
                                       userId={this.props.userId}
                                       isAdmin={this.props.isAdmin}
                                       offlineUserId={this.props.offlineUserId}
                                   />
                               }/>

                        <Route exact path='/' component={HomeContent}/>
                        <Route path='/inquiry' component={InquiryStaticPage}/>

                        <Route path='/order/all'
                               render={(props) =>
                                   <OrderHistory {...props}
                                                 authenticate={this.props.authenticate}
                                                 userData={this.props.userData}
                                                 authenticated={this.props.authenticated}
                                                 userId={this.props.userId}
                                                 user={this.state.user}
                                                 getCartItems={this.getCartItems}/>
                               }/>
                        <Route path='/order/payment/success'
                               render={(props) =>
                                   <StripeSuccessComponent {...props}
                                                           authenticate={this.props.authenticate}
                                                           userData={this.props.userData}
                                                           authenticated={this.props.authenticated}
                                                           userId={this.props.userId}
                                                           user={this.state.user}
                                                           getCartItems={this.getCartItems}/>
                               }/>
                        <Route path='/order/payment/cancelled'
                               render={(props) =>
                                   <PaymentCancelledComponent {...props}
                                                              authenticate={this.props.authenticate}
                                                              userData={this.props.userData}
                                                              authenticated={this.props.authenticated}
                                                              userId={this.props.userId}
                                                              user={this.state.user}
                                                              getCartItems={this.getCartItems}/>
                               }/>
                        <Route path='/order/payment/fail'
                               render={(props) =>
                                   <StripeFailComponent {...props}
                                                        authenticate={this.props.authenticate}
                                                        userData={this.props.userData}
                                                        authenticated={this.props.authenticated}
                                                        userId={this.props.userId}
                                                        user={this.state.user}
                                                        getCartItems={this.getCartItems}/>
                               }/>

                        <Route path='/order/last'
                               render={(props) =>
                                   <LastOrder {...props}
                                              authenticate={this.props.authenticate}
                                              userData={this.props.userData}
                                              authenticated={this.props.authenticated}
                                              userId={this.props.userId}/>
                               }/>
                        <Route path='/order/confirmation'
                               render={(props) =>
                                   <OrderConfirmation {...props}
                                                      authenticate={this.props.authenticate}
                                                      userData={this.props.userData}
                                                      authenticated={this.props.authenticated}
                                                      userId={this.props.userId}
                                                      getCartItems={this.getCartItems}/>
                               }/>

                        <Route path='/inquiry_list'
                               render={(props) =>
                                   <UserInquiry {...props}
                                                authenticate={this.props.authenticate}
                                                userData={this.props.userData}
                                                authenticated={this.props.authenticated}
                                                user={this.state.user}
                                                userId={this.props.userId}/>
                               }/>
                        <Route path='/changePassword'
                               render={(props) =>
                                   <PasswordChange {...props}
                                                authenticate={this.props.authenticate}
                                                userData={this.props.userData}
                                                authenticated={this.props.authenticated}
                                                userId={this.props.userId}/>
                               }/>
                        <Route path='/complaint_list'
                               render={(props) =>
                                   <ComplaintNew {...props}
                                                 authenticate={this.props.authenticate}
                                                 userData={this.props.userData}
                                                 authenticated={this.props.authenticated}
                                                 user={this.state.user}
                                                 userId={this.props.userId}/>
                               }/>
                        <Route path='/quotation/edit/:itemId?'
                               render={(props) =>
                                   <QuotationForm {...props}
                                                  authenticate={this.props.authenticate}
                                                  userData={this.props.userData}
                                                  authenticated={this.props.authenticated}
                                                  userId={this.props.userId}
                                                  getCartItems={this.getCartItems}/>
                               }/>
                        <Route path='/quotation/pcb'
                               render={(props) =>
                                   <QuotationForm {...props}
                                                  authenticate={this.props.authenticate}
                                                  userData={this.props.userData}
                                                  authenticated={this.props.authenticated}
                                                  userId={this.props.userId}
                                                  getCartItems={this.getCartItems}/>
                               }/>
                        <Route path='/quotation/stencil'
                               render={(props) =>
                                   <QuotationForm {...props}
                                                  authenticate={this.props.authenticate}
                                                  userData={this.props.userData}
                                                  authenticated={this.props.authenticated}
                                                  userId={this.props.userId}
                                                  getCartItems={this.getCartItems}/>
                               }/>
                        <Route path='/cart'
                               render={(props) =>
                                   <Cart {...props}
                                         userData={this.props.userData}
                                         userId={this.props.userId}
                                         cartItems={this.state.cartItems}
                                         isGettingCartItems={this.state.isGettingCartItems}
                                         getCartItems={this.getCartItems}/>
                               }/>
                        <Route path='/register'
                               render={(props) =>
                                   <Register {...props}
                                             userData={this.props.userData}
                                             authenticated={this.props.authenticated}
                                             authenticate={this.props.authenticate}
                                             onLanguageChange={this.props.onLanguageChange}/>
                               }
                        />

                        <Route path='/profile'
                               render={(props) =>
                                   <UserProfile {...props}
                                                authenticate={this.props.authenticate}
                                                userData={this.props.userData}
                                                authenticated={this.props.authenticated}
                                                userId={this.props.userId}
                                                isAdmin={this.props.isAdmin}/>
                               }/>

                        <Route path='/logout'
                               render={(props) =>
                                   <Logout {...props}
                                           userData={this.props.userData}/>
                               }
                        />

                        <Route path='/news'
                               render={(props) =>
                                   <InformationList/>
                               }
                        />

                        <Route path='/login' component={Login}
                        />

                        <Route path='/oauth2/handle/:oauthToken?'
                               render={(props) =>
                                   <OAuth2Handler {...props}/>
                               }
                        />

                        <Route path='/authenticate'
                               render={(props) =>
                                   <Authenticate {...props}
                                                 authenticate={this.props.authenticate}
                                                 userData={this.props.userData}
                                                 authenticated={this.props.authenticated}/>
                               }/>
                        <Route path='/auth/signup/:id?'
                               render={(props) =>
                                   <EmailVerify {...props}/>
                               }/>
                        <Route path='/expired-email' component={Emailexpire}/>
                        <Route path='/registered' component={RegisterMsg}/>
                        <Route path='/chat' component={UserChat}/>
                        <Route path='/serviceMenu1' component={NavigationPage1}/>
                        <Route path='/serviceMenu2' component={NavigationPage2}/>
                        <Route path='/serviceMenu3' component={NavigationPage3}/>
                        <Route path='/serviceMenu4' component={NavigationPage4}/>
                        <Route path='/serviceMenu5' component={NavigationPage5}/>
                        <Route path='/serviceMenu6' component={NavigationPage6}/>
                        <Route path='/news' component={NoticeArticle}/>
                        <Route path='/impedance' component={CalculationMainPage}/>
                        <Route path='/stackUp' component={StackUp}/>
                        <Route path="/auth/reset/:id" component={ChangeFogotPassword}/>
                        <Route path="/alreadyVerified" component={AlreadyVerifiedEmail}/>


                        <Route path='/gerber_viewer'
                               render={(props) =>
                                   <GerberReview {...props}
                                                 authenticate={this.props.authenticate}
                                                 userData={this.props.userData}
                                                 authenticated={this.props.authenticated}
                                                 userId={this.props.userId}/>
                               }
                        />

                        <Route path='/userProfileSetting'
                               render={(props) =>
                                   <UserProfileSettingMobile
                                       {...props}
                                       userId={this.props.userId}
                                       userData={this.props.userData}
                                   />
                               }
                        />

                        <Route path='/forgotPassword' component={RecoverPassword}/>


                        <Route path='/help/:id' component={QuotationFieldsHelp}/>


                        <Route path='/manufacture' component={ManufactureDocument}/>

                        <Route path='/course/hajimete-user' component={Beginners}/>
                        <Route path='/course/hajimete-guide' component={Payment}/>
                        <Route path='/course/order' component={Delivery}/>
                        <Route path='/faq' component={FAQ}/>
                        <Route path='/calendar' component={CalendarPage}/>


                        <Route path='/course/hajimete-guide' component={Flow}/>
                        <Route path='/privacy' component={Privacy}/>
                        <Route path='/warranty' component={Warranty}/>
                        <Route path='/use-policy' component={Guide}/>
                        <Route path='/news' component={NoticeArticle}/>

                        <Route path='/contactByChat' component={ContactByChat}/>
                        <Route path='/course/company-profile' component={CompanyProfile}/>


                        <Route path='/aboutpayment' component={AboutPayment}/>
                        <Route path='/cancellation' component={Cancellation}/>
                        <Route path='/customsrequirements' component={CustomsRequirements}/>
                        <Route path='/datacreationandUpload' component={DataCreationAndUpload}/>
                        <Route path='/deliverytime' component={DeliveryTime}/>
                        <Route path='/memberregistration' component={MemberRegistration}/>
                        <Route path='/operatingcompany' component={OperatingCompany}/>
                        <Route path='/other' component={Other}/>
                        <Route path='/productspecifications' component={ProductSpecifications}/>
                        <Route path='/qualityassurance' component={QualityAssurance}/>
                        <Route path='/shipping' component={Shipping}/>
                        <Route path='/yourorder' component={YourOrder}/>

                        <Route path='/aboutpaymentTopic' component={AboutPaymentTopic}/>
                        <Route path='/cancellationTopic' component={CancellationTopic}/>
                        <Route path='/customsrequirementsTopic' component={CustomsRequirementsTopic}/>
                        <Route path='/datacreationandUploadTopic' component={DataCreationAndUploadTopic}/>
                        <Route path='/deliverytimeTopic' component={DeliveryTimeTopic}/>
                        <Route path='/memberregistrationTopic' component={MemberRegistrationTopic}/>
                        <Route path='/operatingcompanyTopic' component={OperatingCompanyTopic}/>
                        <Route path='/otherTopic' component={OtherTopic}/>
                        <Route path='/productspecificationsTopic' component={ProductSpecificationsTopic}/>
                        <Route path='/qualityassuranceTopic' component={QualityAssuranceTopic}/>
                        <Route path='/shippingTopic' component={ShippingTopic}/>
                        <Route path='/yourorderTopic' component={YourOrderTopic}/>

                        <Route path='/footerNavPage1' component={footerNavPage1}/>
                        <Route path='/footerNavPage2' component={footerNavPage2}/>
                        <Route path='/footerNavPage3' component={footerNavPage3}/>
                        <Route path='/footerNavPage4' component={footerNavPage4}/>
                        <Route path='/footerNavPage5' component={footerNavPage5}/>
                        <Route path='/footerNavPage6' component={footerNavPage6}/>


                        {/*<Route path='/userProfileSetting' component={UserProfileSettingMobile}/>*/}


                    </Switch>

                    <Fragment>
                        <Footer/>
                    </Fragment>
                </Fragment>
            </Fragment>
        )
    }
}

export default SiteRoot;



// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/SiteRoot.js